@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) '../grid-layouts.module.less';

@two-column-breakpoint: 888px;

.order-details-selected-content-grid-layout-container {
  container-type: inline-size;

  flex: 1;
  display: flex;
  flex-flow: column nowrap;
}

.order-details-selected-content-grid-layout {
  flex: 1;
  display: grid;

  // Default legacy layout for backward compatibility
  .order-details-selected-content-one-column-legacy-layout();

  // User-selected layout modes (when customize mode is active)
  &[data-layout-mode='1'] {
    .order-details-selected-content-one-column-grid-layout();
  }

  &[data-layout-mode='2'] {
    .order-details-selected-content-two-column-grid-layout();
  }

  &[data-layout-mode='3'] {
    .order-details-selected-content-three-column-grid-layout();
  }
}

// Responsive layout (when not in customize mode)
@container (min-width: @two-column-breakpoint) {
  .order-details-selected-content-grid-layout:not([data-layout-mode]) {
    .order-details-selected-content-two-column-legacy-layout();
  }
}
